import { push } from '@lagunovsky/redux-react-router'
import HomeAction from 'home/actions/HomeAction'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { H_PIEZO_CAMPAIGN } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import DashboardCampaigns from '../../../campaign/components/DashboardCampaigns'
import ProgressCard from '../../../components/card/ProgressCard'
import { PATH_PIEZOMETRY, PATH_PIEZOMETRY_CAMPAIGN } from '../../../home/constants/RouteConstants'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'
import useTitle from 'utils/customHook/useTitle'
import useAbortController from 'utils/customHook/useAbortController'
import { PiezometryActionConstant } from 'piezometry/reducers/PiezometryReducer'


const PiezometryCampaignsApp = () => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [progress, setProgress] = useState(0)

    const {
        piezometryCampaigns,
        piezometryCampaignsProgress,
    } = useSelector(store => ({
        piezometryCampaigns: store.PiezometryReducer.piezometryCampaigns,
        piezometryCampaignsProgress: store.PiezometryReducer.piezometryCampaignsProgress,
    }), shallowEqual)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!componentHasHabilitations(H_PIEZO_CAMPAIGN)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(HomeAction.setHelpLink('piezometrie', ''))
        dispatch(CampaignAction.loadPiezometryCampaigns(p => setProgress(p))).then(() => setDataLoaded(true))
    }, [])

    useTitle(() => [{
        title: i18n.piezometry,
        href: PATH_PIEZOMETRY,
    }, {
        title: i18n.campaigns,
        href: PATH_PIEZOMETRY_CAMPAIGN,
    }], [])

    const {
        controllerRef,
        initController,
    } = useAbortController()

    useEffect(() => {
        initController()
        if (piezometryCampaigns.length) {
            dispatch(CampaignAction.getCampaignProgressSequentially(STATION_TYPE_NAME.piezometry, piezometryCampaigns, controllerRef.current.signal))
        }
        return () => dispatch(PiezometryActionConstant.receivePiezometryCampaignsProgress([])) // reset campaign stats progress on unmount
    }, [piezometryCampaigns, controllerRef])

    if (dataLoaded) {
        return (
            <DashboardCampaigns
                campaigns={piezometryCampaigns}
                campaignsProgress={piezometryCampaignsProgress}
                stationType={STATION_TYPE_NAME.piezometry}
            />
        )
    }
    return <ProgressCard progress={ progress }/>
}

export default PiezometryCampaignsApp
